import { Flare } from "@mui/icons-material";
import IconButton from "@mui/material/IconButton";

import {
  actions,
  PlotPanelState,
  useVizDispatch,
} from "@/shared/state/visualization";

interface DisplayEventsButtonProps {
  state: PlotPanelState;
}

export function DisplayEventsButton({ state }: DisplayEventsButtonProps) {
  const dispatch = useVizDispatch();
  const showEvents = state.config?.showEvents ?? true;

  return (
    <IconButton
      aria-label="display-events-toggle"
      onClick={() => {
        dispatch(
          actions.setPlotPanelConfig(state.id, {
            showEvents: !showEvents,
          }),
        );
      }}
      size="small"
      title="Show/hide events"
    >
      <Flare color={showEvents ? "primary" : "inherit"} fontSize="small" />
    </IconButton>
  );
}
